/** @file Stepped sampler for draw-order timelines: full permutations, null meaning the setup order. */
import type { TimelineHandler } from '../../contracts/timeline';
import { locateKey, type KeyCursor } from './locateKey';

const cur: KeyCursor = { k0: 0, k1: 0, u: 0 };

/** Copies the held key's permutation (identity for a null key) into Sample.drawOrder and marks it keyed. */
export const drawOrderHandler: TimelineHandler<'drawOrder'> = {
  sample(tl, time, lastTime, out) {
    if (!locateKey(tl.times, time, cur)) return;
    const order = tl.values[cur.k0] ?? null;
    const dst = out.drawOrder;
    for (let i = 0; i < dst.length; i++) dst[i] = order === null ? i : (order[i] ?? i);
    out.drawOrderKeyed = true;
  },
};
